import { render, staticRenderFns } from "./BoxesGridMulti.vue?vue&type=template&id=0611ef0e&scoped=true&"
import script from "./BoxesGridMulti.vue?vue&type=script&lang=js&"
export * from "./BoxesGridMulti.vue?vue&type=script&lang=js&"
import style0 from "./BoxesGridMulti.vue?vue&type=style&index=0&id=0611ef0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0611ef0e",
  null
  
)

export default component.exports